/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_All_ToastInputs */



/**
* | output |
* | --- |
* | "All results replaced successfully" |
*
* @param {Find_Replace_Replace_All_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_all_toast = /** @type {((inputs?: Find_Replace_Replace_All_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_All_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les resultats ont ete remplaces avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ergebnisse wurden erfolgreich ersetzt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i risultati sono stati sostituiti con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все результаты успешно заменены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los resultados fueron reemplazados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有结果均已成功替换。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての結果が正常に置き換えられました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी परिणाम सफलतापूर्वक बदल दिए गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os resultados foram substituídos com sucesso.")
	return /** @type {LocalizedString} */ ("All results replaced successfully")
});